var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"top-box"},[_c('img',{staticClass:"bgImg",attrs:{"src":require("../../../static/images/index/bg2.png")}}),_c('div',[_vm._v("参展指南")])]),_c('div',{staticClass:"noActivity"},[_c('span',{staticClass:"iconfont icon-kulian"}),_c('div',[_vm._v("2026年资料未更新")])])])
}]

export { render, staticRenderFns }